module.exports = __webpack_public_path__ + "img/lancome_back_arrow.e137a038.svg";